import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import BuildVersion from './components/BuildVersion.vue';
import './styles/app.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
// Footer build stamp — registered globally so every page's footer can drop
// <BuildVersion /> without importing it locally.
app.component('BuildVersion', BuildVersion);
app.mount('#app');
